import "client-only";
import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";

function useBankInfoList(params) {
  return useSWR(
    {
      path: `/api/v1/bank-infos`,
      method: "GET",
      params,
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useBankInfoList;

